import {createSelector} from 'reselect'

const stateReducer = state => state.dashboardReducer;

export const selectFetching = (initData) =>
    createSelector(
        stateReducer,
        dashboardReducer => dashboardReducer.isFetching
    )

export const selectUserActivity = (initItems) =>
    createSelector(
        stateReducer,
        dashboardReducer => dashboardReducer.userActivity
    )

export const selectDailyUserActivity = (initItems) =>
    createSelector(
        stateReducer,
        dashboardReducer => dashboardReducer.dailyUserActivity
    )

export const selectCityFilter = (initItems) =>
    createSelector(
        stateReducer,
        dashboardReducer => dashboardReducer.cityFilter
    )

export const selectImportCounty = (initItems) =>
    createSelector(
        stateReducer,
        dashboardReducer => dashboardReducer.county
    )

export const selectImportLeadType = (initItems) =>
    createSelector(
        stateReducer,
        dashboardReducer => dashboardReducer.leadType
    )
